import React, {
  type ComponentType,
  type CSSProperties,
  type FC,
  type ReactNode,
  useEffect,
} from 'react';

import type { UsersUserSchema } from '@iconik-io/iconik-api/src/services/users';

import { getBasicUser } from '../../ducks/user/actions';
import { useAppDispatch, useAppSelector } from '../../store/react_redux_typed';

type WrappedComponentProps = {
  className?: string;
  style?: CSSProperties;
};

type Props = {
  component?: ComponentType<WrappedComponentProps> | string;
  id: string;
  className?: string;
  style?: CSSProperties;
  nowrap?: boolean;
  children: ({ user }: { user: Partial<UsersUserSchema> }) => ReactNode;
};

const AsyncUser: FC<Props> = ({
  id,
  style,
  className,
  children,
  component = 'div',
  nowrap,
}) => {
  const dispatch = useAppDispatch();
  const user =
    useAppSelector(
      (state) => state.entities.users_basic[id] ?? state.entities.users[id],
    ) ?? {};

  useEffect(() => {
    dispatch(getBasicUser(id));
  }, [id]);

  const CustomComponent = nowrap ? React.Fragment : component;

  const props: WrappedComponentProps = {};
  if (!nowrap) {
    props.style = style;
    props.className = className;
  }

  return <CustomComponent {...props}>{children({ user })}</CustomComponent>;
};

export default AsyncUser;
